import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_c(VDialog, {
    attrs: {
      "max-width": "900"
    },
    model: {
      value: _vm.formDialog,
      callback: function ($$v) {
        _vm.formDialog = $$v;
      },
      expression: "formDialog"
    }
  }, [_vm.formDialog ? _c('niota-classic-applications-form', {
    attrs: {
      "editedItem": _vm.editedItem
    },
    on: {
      "close": _vm.closeForm,
      "refreshList": _vm.updateList,
      "created": _vm.updateList
    }
  }) : _vm._e()], 1), _c('core-header', {
    attrs: {
      "headline": _vm.$i18n_t('NiotaClassic.Applications.title'),
      "subtitle": _vm.$i18n_t('NiotaClassic.Applications.applicationsListSubheader')
    },
    on: {
      "addItem": _vm.addItem
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c('niota-classic-common-account-filter', {
          attrs: {
            "iconOnly": _vm.isMobile,
            "initiallySelected": _vm.getAccountsIdsFromQueryParams(),
            "multiple": "",
            "n1Accounts": ""
          },
          on: {
            "selected": accounts => {
              _vm.selectedAccounts = accounts;
            },
            "reset-filter": _vm.resetFilter,
            "accounts-loaded": () => {
              _vm.isLoadingAccounts = false;
            }
          }
        }), _c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-plus",
            "disabled": !_vm.isIotHubManager
          },
          on: {
            "click": function ($event) {
              return _vm.addItem();
            }
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('NiotaClassic.Applications.create')) + "\n      ")])];
      },
      proxy: true
    }])
  }), _c(VRow, {
    staticClass: "n20-mainrow",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('core-n20Card', [!_vm.isLoadingAccounts ? _c('niota-classic-applications-list', {
    ref: "list",
    attrs: {
      "selectedAccounts": _vm.selectedAccounts
    },
    on: {
      "edit-item": _vm.editItem
    }
  }) : _vm._e()], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };